
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/manage-subscriptions",
      function () {
        return require("private-next-pages/manage-subscriptions/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/manage-subscriptions"])
      });
    }
  